import React from "react";
import { NavLink } from "react-router-dom";

const TournamentCard = (props) => {


    return (
        <center> 
            <div class="rem" >
            <NavLink to={`/lmi/tournament/${props.id}`} >
            <div class="tournamentCard blur-in" >
                    <img class="imggame" src={props.image} alt={props.name} />
                    <div class="tourText">
                        <div class="tituloTorneo">
                            {props.name}
                        </div>
                        <div class="description">
                            {props.description}
                        </div>
                    </div>

                
            </div>
            </NavLink>
            </div>
        </center>
    )
}

export default TournamentCard